<!-- Top left: where the item came from. -->
@if (slots.tl; as badge) {
  <app-icon [class]="'subicon subicon--tl ' + (badge.cls || '')" [src]="badge.src"
    [width]="sizePx" [height]="sizePx"
    [skyTooltip]="showTooltips ? badge.tooltip : undefined">
  </app-icon>
}

<!-- Top right: which season. -->
@if (slots.tr; as badge) {
  <app-icon [class]="'subicon subicon--tr ' + (badge.cls || '')" [src]="badge.src"
    [width]="sizePx" [height]="sizePx"
    [skyTooltip]="showTooltips ? badge.tooltip : undefined">
  </app-icon>
}

<!-- Bottom left: the star sits above the emote level. -->
@if (slots.star || slots.level) {
  <span class="subicon-stack">
    @if (slots.star) {
      <mat-icon class="subicon-star"
        [skyTooltip]="showTooltips ? 'This item is on your wishlist.' : undefined">
        star
      </mat-icon>
    }
    @if (slots.level) {
      <span class="subicon-level">Lv{{ slots.level }}</span>
    }
  </span>
}

<!-- Bottom right: owned, or the limited marker while it is not. -->
@if (slots.dot; as dot) {
  <span class="subicon-dot" [class.subicon-dot--self]="dot === 'self'"
    [skyTooltip]="showTooltips ? (dot === 'self' ? 'You own this item.' : 'You own this item through another source.') : undefined">
    <svg class="subicon-dot__check" viewBox="0 0 16 16" aria-hidden="true"><path d="M4 8.5l2.5 2.5L12 5"/></svg>
  </span>
} @else if (slots.br) {
  <mat-icon [class]="'subicon subicon--br ' + (slots.br.cls || '')"
    [skyTooltip]="showTooltips ? slots.br.tooltip : undefined">
    {{ slots.br.src }}
  </mat-icon>
}
